// extracted by mini-css-extract-plugin
export default {"close":"modal-module--close--wqN+L","body":"modal-module--body--WZr4w"};